import Container from '@mui/material/Container'

import Heading from '~/client/components/Heading'

export default function AboutPage() {
  return <Container>
    <Heading my={4} variant="major">Developer</Heading>
    <p>DataPal is in early Alpha.</p>
    <p>
      {`To register as for the developer application program send an introductory email to `}
      <a href="mailto:developers@datapal.me">developers@datapal.me</a>
    </p>
  </Container>
}
